import Sanitizing from './util/Sanitizing'

export default class GetCookie {
  private cookies = new Map<string, string>()

  constructor() {
    this.createMap()
  }

  /**
   * キーが存在するかチェックする
   * @param key キー名
   */
  public hasKey(key: string): boolean {
    return this.cookies.has(key)
  }

  /**
   * cookieを取得する
   *
   * 取得できなかった場合、空を返却する
   *
   * @param key キー名
   * @return 値
   */
  public get(key: string): string {
    const value = this.cookies.get(key)
    return value || ''
  }

  /**
   * パターンにマッチするCookie名を取得する
   *
   * マッチしなかった場合、空のリストを返却する
   *
   * @param preg パターン
   * @return cookie名
   */
  public match(preg: string | RegExp): string[] {
    const matchCookieList: string[] = []

    this.cookies.forEach((value, key) => {
      if (key.match(preg)) {
        matchCookieList.push(key)
      }
    })

    return matchCookieList
  }

  /**
   * Cookie情報をMapにセットする
   * - キーと値両方存在する場合のみ追加する
   * - それ以外は無視する
   */
  private createMap(): void {
    const cookieStr = document.cookie
    const cookies = cookieStr.split(';')
    cookies.forEach((cookie) => {
      const keyAndValue = cookie.split('=')
      if (keyAndValue[0] && keyAndValue[1]) {
        const key = keyAndValue[0].trim()
        const value = keyAndValue[1].trim()
        this.cookies.set(key, Sanitizing.urlBasicSanitizing(value))
      }
    })
  }

  /**
   * Cookieの再読み込み
   */
  public reload(): void {
    this.createMap()
  }
}
